export * from './functions';

export function getAvatarColor(initials: ?string) {
    return `rgba(12, 77, 136, 1)`;
}